document.addEventListener("DOMContentLoaded", () => {
  // Select all menu items for the first class
  const menuItems = document.querySelectorAll(".menu__item");

  // Loop through each item and add the dynamic class
  menuItems.forEach((item, index) => {
    const dynamicClass = `menu__item-${index + 1}`;
    item.classList.add(dynamicClass);
  });

  // Select all mobile menu items for the second class
  const mobileMenuItems = document.querySelectorAll(".menu_mobile_item");

  // Loop through each item and add the dynamic class
  mobileMenuItems.forEach((item, index) => {
    const dynamicClass = `menu_mobile_item-${index + 1}`;
    item.classList.add(dynamicClass);
  });
});
